/**
 * @generated SignedSource<<c422812a30a34f5c31cd0430d4f19a08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CardBrand = "AMERICAN_EXPRESS" | "CHINA_UNIONPAY" | "DISCOVER" | "DISCOVER_DINERS" | "EBT" | "EFTPOS" | "FELICA" | "INTERAC" | "JCB" | "MASTERCARD" | "OTHER_BRAND" | "SQUARE_CAPITAL_CARD" | "SQUARE_GIFT_CARD" | "UNKNOWN" | "VISA";
export type CreateUserCardOnFileInput = {
  squareNonce: string;
};
export type useCreateUserCardOnFileMutation$variables = {
  input: CreateUserCardOnFileInput;
};
export type useCreateUserCardOnFileMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly squareCard: {
      readonly cardBrand: CardBrand;
      readonly default: boolean;
      readonly enabled: boolean;
      readonly id: string;
      readonly lastFour: string;
      readonly user: {
        readonly squareCards: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly " $fragmentSpreads": FragmentRefs<"SquareCardFragment">;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"SelectedPaymentMethodFragment" | "SquareCardFragment">;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useCreateUserCardOnFileMutation = {
  response: useCreateUserCardOnFileMutation$data;
  variables: useCreateUserCardOnFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cardBrand",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastFour",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "default",
  "storageKey": null
},
v11 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "SquareCardFragment"
},
v12 = [
  {
    "kind": "Literal",
    "name": "enabled",
    "value": true
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expMonth",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expYear",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateUserCardOnFileMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreateUserCardOnFilePayload",
        "kind": "LinkedField",
        "name": "createUserCardOnFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SquareCardOnFile",
            "kind": "LinkedField",
            "name": "squareCard",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SelectedPaymentMethodFragment"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "SquareCardOnFileConnection",
                    "kind": "LinkedField",
                    "name": "squareCards",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareCardOnFileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SquareCardOnFile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "squareCards(enabled:true)"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateUserCardOnFileMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreateUserCardOnFilePayload",
        "kind": "LinkedField",
        "name": "createUserCardOnFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SquareCardOnFile",
            "kind": "LinkedField",
            "name": "squareCard",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "SquareCardOnFileConnection",
                    "kind": "LinkedField",
                    "name": "squareCards",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareCardOnFileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SquareCardOnFile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v13/*: any*/),
                              (v7/*: any*/),
                              (v9/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v8/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "squareCards(enabled:true)"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberPackageConnection",
                "kind": "LinkedField",
                "name": "memberPackages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "20ead16917fcc6447d875f01b6104a68",
    "id": null,
    "metadata": {},
    "name": "useCreateUserCardOnFileMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateUserCardOnFileMutation(\n  $input: CreateUserCardOnFileInput!\n) {\n  responsePayload: createUserCardOnFile(input: $input) {\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    success\n    squareCard {\n      id\n      cardBrand\n      lastFour\n      enabled\n      default\n      ...SquareCardFragment\n      ...SelectedPaymentMethodFragment\n      user {\n        squareCards(enabled: true) {\n          edges {\n            node {\n              id\n              ...SquareCardFragment\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment SelectedPaymentMethodFragment on SquareCardOnFile {\n  id\n  cardBrand\n  enabled\n  expMonth\n  expYear\n  lastFour\n  default\n  user {\n    id\n  }\n  memberPackages {\n    count\n  }\n}\n\nfragment SquareCardFragment on SquareCardOnFile {\n  __typename\n  id\n  cardBrand\n  enabled\n  expMonth\n  expYear\n  lastFour\n  default\n}\n"
  }
};
})();

(node as any).hash = "270e2d99fec364deadbc4804264b7a6d";

export default node;
